import { createStyles, makeStyles } from '@material-ui/core/styles';

export const userProfileStyles = makeStyles(theme =>
  createStyles({
    mainContent: {
      marginTop: '16px'
    }
  })
);
